/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddRecipientRequest
 */
export interface AddRecipientRequest {
    /**
     * 
     */
    participant_id: string;
}

/**
 * Check if a given object implements the AddRecipientRequest interface.
 */
export function instanceOfAddRecipientRequest(value: object): value is AddRecipientRequest {
    if (!('participant_id' in value) || value['participant_id'] === undefined) return false;
    return true;
}

export function AddRecipientRequestFromJSON(json: any): AddRecipientRequest {
    return AddRecipientRequestFromJSONTyped(json, false);
}

export function AddRecipientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddRecipientRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'participant_id': json['participant_id'],
    };
}

export function AddRecipientRequestToJSON(json: any): AddRecipientRequest {
    return AddRecipientRequestToJSONTyped(json, false);
}

export function AddRecipientRequestToJSONTyped(value?: AddRecipientRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'participant_id': value['participant_id'],
    };
}

